import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, MapPin } from "lucide-react";
import { api, money } from "../lib/api";
import { TicketDialog } from "../components/site/TicketDialog";
import { HeroVideo } from "../components/site/HeroVideo";
import { ActionButtons } from "../components/site/ActionButtons";

const HERO_VIDEO = "/00shots-hero.mp4";
const HERO_POSTER = "/00shots-hero-poster.jpg";
const today = () => new Date().toISOString().slice(0, 10);

export const ShowRow = ({ c, onPick }) => (
  <div data-testid={`show-row-${c.id}`} className="group grid grid-cols-[64px_1fr] sm:grid-cols-[110px_1fr_auto] gap-4 sm:gap-8 items-center py-6 border-b border-[#222634]">
    <div className="font-cond uppercase leading-none">
      <div className="text-lime text-sm tracking-widest">{new Date(c.date + "T00:00").toLocaleDateString([], { month: "short" })}</div>
      <div className="text-4xl sm:text-5xl font-black">{c.date.slice(8)}</div>
    </div>
    <div className="min-w-0">
      <Link to={`/shows/${c.id}`} data-testid={`show-link-${c.id}`} className="block font-cond uppercase font-bold text-xl sm:text-2xl tracking-wide truncate hover:text-lime transition-colors">{c.title}</Link>
      <p className="text-sm text-slate-400 flex items-center gap-1.5 mt-1"><MapPin className="w-3.5 h-3.5 shrink-0" /> <span className="truncate">{c.venue}, {c.city} · {c.time}</span></p>
    </div>
    <button onClick={() => onPick(c)} data-testid={`show-tickets-button-${c.id}`}
      className="col-span-2 sm:col-span-1 btn-lime rounded-full px-6 py-3 font-cond uppercase font-bold tracking-widest">
      Tickets · {money(c.price)}
    </button>
  </div>
);

export const DatesTBD = ({ testid = "shows-tbd" }) => (
  <div data-testid={testid} className="card-surface rounded-2xl px-6 py-10 text-center">
    <p className="font-gothic text-5xl sm:text-6xl text-lime">TBD</p>
    <p className="font-cond uppercase tracking-[0.3em] text-sm text-slate-400 mt-3">Dates coming soon</p>
  </div>
);

export default function Home() {
  const [shows, setShows] = useState(null);
  const [pick, setPick] = useState(null);

  useEffect(() => {
    api.concerts().then((c) => setShows(c.filter((x) => x.date >= today()).slice(0, 3))).catch(() => setShows([]));
  }, []);

  return (
    <>
      <HeroVideo src={HERO_VIDEO} poster={HERO_POSTER} />
      <section className="px-5 lg:px-12 pt-10 pb-4">
        <ActionButtons prefix="home-action" className="max-w-4xl mx-auto" />
      </section>
      <section className="px-5 lg:px-12 py-16 max-w-5xl mx-auto">
        <div className="flex items-end justify-between gap-4 mb-6">
          <h2 className="font-gothic text-4xl sm:text-5xl">Shows</h2>
          <Link to="/shows" data-testid="home-all-shows-link" className="text-lime font-cond uppercase tracking-widest text-sm inline-flex items-center gap-2">Calendar <ArrowRight className="w-4 h-4" /></Link>
        </div>
        {shows && shows.length === 0 && <DatesTBD testid="home-shows-tbd" />}
        {(shows || []).map((c) => <ShowRow key={c.id} c={c} onPick={setPick} />)}
      </section>
      <TicketDialog concert={pick} onClose={() => setPick(null)} />
    </>
  );
}
